<template>
  <PVDialog
    v-bind="$attrs"
    :visible="visible"
    :header="title"
    :modal="blocking"
    :draggable="draggable"
    :class="dialogClasses"
    :closable="closable"
    :close-on-escape="blocking"
    :dismissable-mask="false"
    @update:visible="onVisibleChange"
  >
    <template #header>
      <div class="flex items-center w-full" :class="headerClasses">
        <slot name="preTitle"></slot>
        <TIcon
          v-if="titleIcon"
          :icon="titleIcon"
          :color="titleIconColor"
          class="mr-2"
          width="20"
          height="20"
        />
        <h4 :class="titleClasses">
          {{ title }}
        </h4>
        <div class="flex items-center justify-center space-x-2 flex-1">
          <slot name="titleActions"></slot>
        </div>
      </div>
    </template>

    <!-- Forward default slot only since we're handling header and footer separately -->
    <slot></slot>

    <template #footer>
      <div v-if="!!$slots.actions" class="flex justify-end space-x-2">
        <slot name="actions"></slot>
      </div>
    </template>
  </PVDialog>
</template>

<script lang="ts">
import Dialog from 'primevue/dialog'
import { defineComponent, SlotsType } from 'vue'
import TIcon from '../icon/TIcon.vue'
import { setup } from './controller'
import { T_DIALOG_PROPS } from './types'

export default defineComponent({
  name: 'TDialog',
  components: {
    PVDialog: Dialog,
    TIcon,
  },
  props: T_DIALOG_PROPS,
  emits: ['close', 'open', 'update:visible'],
  slots: Object as SlotsType<{
    default: void
    preTitle: void
    titleActions: void
    actions: void
  }>,
  setup,
})
</script>

<style lang="scss">
// WARNING, UNSCOPED
// This is intentional -- the class will not apply to the dialog otherwise
// even with :deep applied
// due to dom Teleports
.p-dialog {
  &.t-dialog-warning {
    @apply bg-nash-tigerlily100;
  }

  &.t-dialog-sm {
    @apply w-1/4 max-h-3/4;
  }

  &.t-dialog-md,
  &.t-dialog-lg {
    @apply w-3/4 lg:w-1/2;
  }

  &.t-dialog-md {
    @apply max-h-95pct;
  }

  &.t-dialog-lg {
    @apply max-h-856 h-5/6;
  }
}
</style>
